import Lottie from "lottie-react";
import PropTypes from "prop-types";
import loaderAnimation from "../../../assets/loader/loader.json";
import { Box } from "@mui/material";

const Loader = ({ open = false }) => {
  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",

        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: 2000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Lottie
        animationData={loaderAnimation}
        loop
        style={{ width: 200, height: 200 }}
      />
    </Box>
  );
};

Loader.propTypes = {
  open: PropTypes.bool,
};

export default Loader;
